// extracted by extract-css-chunks-webpack-plugin
module.exports = {"table":"table-wrap__table--3AGTQ"};